import React from 'react'
import {useLoaderData} from "react-router";
import {VlogPlayer} from "../../models/vlogs/player";

export const ReplayDashboard = props => {
  const {replay} = useLoaderData()

  return <VlogPlayer vlog={replay.vlog} replay={replay} />
}